<template>
    <div class="w-tip">
        <i class="w-tip__icon" :class="icon" :style="{ color: iconColor }"></i>
        <span class="w-tip__content">
            <slot>{{ content }}</slot>
        </span>
    </div>
</template>

<script>
export default {
    name: "WidgetTip",
    props: {
        content: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "fa-solid fa-circle-info",
        },
        iconColor: {
            type: String,
            default: "#3b82f6",
        },
    },
};
</script>

<style lang="less">
@import "~@/assets/css/widget/tip.less";
</style>
